import { render, staticRenderFns } from "./EyesightList.vue?vue&type=template&id=3515f752&"
import script from "./EyesightList.vue?vue&type=script&lang=js&"
export * from "./EyesightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports